import React from 'react';
import { useSelector, RootStateOrAny } from 'react-redux';
import { useNavigation } from '~/hooks';
import { isMobileNumber, isUSNumber } from '~/helpers';
import { NewSession } from '~/components/ActiveCall/types';
import { Textsms } from './styles';

type SendSMSButtonProps = {
  session: NewSession;
};

const SendSMS = ({ session }: SendSMSButtonProps) => {
  const { answered, numberFrom } = session;

  const navigate = useNavigation();

  const userCountry = useSelector(
    (state: RootStateOrAny) => state.auth.userCountry
  );

  const hasSMSCapability =
    isMobileNumber(numberFrom, userCountry) || isUSNumber(numberFrom);

  const handleClickSMSButton = () => {
    navigate.smsSenderView({
      name: numberFrom,
      mobile: numberFrom,
    });
  };

  return (
    <>
      {answered && hasSMSCapability && (
        <button
          type="button"
          title="SMS"
          disabled={!answered}
          onClick={handleClickSMSButton}>
          <Textsms />
        </button>
      )}
    </>
  );
};

export default SendSMS;
